import { createSignal, For, type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import { CARD_SIZES, type CardSize, type CardSizes } from '../../lib/card-size';
import { MoveIcon } from './MoveIcon';

// "Card size" above the Cards view's grid (#6785, prototype toolbarHTML + mxAll,
// `:2576-2631`): Full or Simplified for every card at once, pressed buttons in the view
// switch's own frame. A card's chevron overrides it for that card. The change is said in a
// polite live region ("All cards simplified"), since nothing focused moves. Beside it, for an
// admin (`hint`), the prototype's drag hint (#6771): "Drag a job or an epic onto another card
// to move it."

const LABEL: Readonly<Record<CardSize, string>> = {
  full: 'fleet.machines.card_size_full',
  simplified: 'fleet.machines.card_size_simplified',
};

const SAID: Readonly<Record<CardSize, string>> = {
  full: 'fleet.machines.card_all_expanded',
  simplified: 'fleet.machines.card_all_simplified',
};

export function CardSizeControl(props: {
  readonly sizes: CardSizes;
  /** Show the drag hint: the person may move work (an admin). */
  readonly hint?: boolean;
}): JSX.Element {
  const [said, setSaid] = createSignal('');
  return (
    <div class="mission-size">
      <Show when={props.hint === true}>
        <p class="mission-size__hint">
          <MoveIcon glyph="grip" />
          <span>{t('fleet.move.toolbar_hint')}</span>
        </p>
      </Show>
      <fieldset class="fleet-view-switch">
        <legend class="sr-only">{t('fleet.machines.card_size')}</legend>
        <For each={CARD_SIZES}>
          {(size) => (
            <button
              type="button"
              class="fleet-view-switch__btn"
              aria-pressed={props.sizes.all() === size}
              onClick={() => {
                props.sizes.setAll(size);
                setSaid(t(SAID[size]));
              }}
            >
              {t(LABEL[size])}
            </button>
          )}
        </For>
      </fieldset>
      <span class="sr-only" aria-live="polite">
        {said()}
      </span>
    </div>
  );
}
